const autoNgTemplateLoaderTemplate1 = require('./por-image-registry.html');

angular.module('portainer.docker').component('porImageRegistry', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'porImageRegistryController',
  bindings: {
    model: '=', // must be of type PorImageRegistryModel
    pullWarning: '<',
    autoComplete: '<',
    labelClass: '@',
    inputClass: '@',
    endpoint: '<',
    isAdmin: '<',
    namespace: '<',

    checkRateLimits: '<',
    onImageChange: '&',
    setValidity: '<',
  },
  require: {
    form: '^form',
  },
  transclude: true,
});
